import type { FeatureFlagValue } from './common/types';
import { redactValue } from './common/utils';

export { redactValue } from './common/utils';
export type { FeatureFlagValue } from './common/types';

export const allFeatureFlagsAccessed: Map<string, FeatureFlagValue> = new Map();

export const currentFeatureFlagsAccessed: Map<string, FeatureFlagValue> = new Map();

/**
 * Used for tracking accessed feature flags in "@atlassian/jira-feature-flagging".
 * */
export const addFeatureFlagAccessed = (
	featureFlagName: string,
	featureFlagValue: FeatureFlagValue,
) => {
	const value = redactValue(featureFlagValue);
	allFeatureFlagsAccessed.set(featureFlagName, value);
	currentFeatureFlagsAccessed.set(featureFlagName, value);
};
